import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromName from './name-reducer';
import * as fromPlanRole from './planrole.reducer';
import * as fromAddress from './address.reducer';
import * as fromPlanNum from './plannum.reducer';
//import * as fromRootStore from 'lib-rod-core';
import * as fromPlanCertType from './plancerttype.reducer';
import * as fromRoleType from './roletype.reducer';
import * as fromCompoundName from './compoundname.reducer';

import * as fromCity from './citytown.reducer';
import * as fromRole from './role.reducer';
import * as fromContains from './contains.reducer';
import * as fromSelectIndex from './selectindex.reducer';
import * as fromDate from './daterange.reducer';
import * as fromDoct from './doctype.reducer';
import * as fromDocNum from './docnum.reducer';
import * as fromBP from './bookpage.reducer';
import * as fromAmount from './amountrange.reducer';
import * as fromDocCategories from './doccategories.reducer';
import * as fromDocCategories2 from './doccategories2.reducer';

export interface CoreSearchDataState {
  name: fromName.NameState;
  planrole: fromPlanRole.PlanRoleState;
  address: fromAddress.AddressState;
  plannum: fromPlanNum.PlanNumState;
  plancerttype: fromPlanCertType.PlanCertTypeState;
  roletype: fromRoleType.RoleTypeState;
  compoundname: fromCompoundName.CompoundNameState;
  contains: fromContains.ContainsState;
  selectindex: fromSelectIndex.SelectIndexState;
  role: fromRole.RoleState;
  city: fromCity.CityState;
  date: fromDate.DateState;
  doct: fromDoct.DoctState;
  docnum: fromDocNum.DocNumState;
  bp: fromBP.BPState;
  amount: fromAmount.AmountState;
  docCategoriesVS: fromDocCategories.DocCategoriesState;
  docCategories2: fromDocCategories2.DocCategories2State;
}

export const reducers: ActionReducerMap<CoreSearchDataState> = {
  name: fromName.reducer,
  planrole: fromPlanRole.reducer,
  address: fromAddress.reducer,
  plannum: fromPlanNum.reducer,
  plancerttype: fromPlanCertType.reducer,
  roletype: fromRoleType.reducer,
  compoundname: fromCompoundName.reducer,
  contains: fromContains.reducer,
  selectindex: fromSelectIndex.reducer,
  role: fromRole.reducer,
  city: fromCity.reducer,
  date: fromDate.reducer,
  doct: fromDoct.reducer,
  docnum: fromDocNum.reducer,
  bp: fromBP.reducer,
  amount: fromAmount.reducer,
  docCategoriesVS: fromDocCategories.reducer,
  docCategories2: fromDocCategories2.reducer
};

export const getRegSearchState = createFeatureSelector<CoreSearchDataState>('coresearchdata');




